// import secureLocalStorage from "react-secure-storage";

const secureStore = {
  setItemAsync: (key, value) => localStorage.setItem(key, value),
  getItemAsync: (key) => localStorage.getItem(key),
  removeItemAsync: (key) => localStorage.removeItem(key),
};

export default secureStore;
